import * as React from "react";
const IconUnderlineCopy = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M32 48.8c11.5 0 20.8-9.1 20.8-20.3V3c0-.6-.4-1-1-1s-1 .4-1 1v25.5c0 10.1-8.4 18.3-18.8 18.3s-18.8-8.2-18.8-18.3V3c0-.6-.4-1-1-1s-1 .4-1 1v25.5c0 11.2 9.3 20.3 20.8 20.3M57.1 60H6.9c-.6 0-1 .4-1 1s.4 1 1 1H57c.6 0 1-.4 1-1s-.4-1-.9-1" />
  </svg>
);
export default IconUnderlineCopy;
